module.exports = "/_next/static/images/OneApi@3x-08870a645e110c1ae64b56ac59809930.webp";